import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import logo from '../../../assets/Rolf-Wittmer-Galapagos-Cruises-Logo.png'
import { FaBars, FaFacebook, FaInstagram, FaLinkedin, FaWhatsapp } from "react-icons/fa6";
import { RiMailSendLine } from "react-icons/ri";
import { FaTimes, FaYoutube } from 'react-icons/fa';

const Navbar = ({ yachtState }) => {

  const [nav, setNav] = useState(false);
  const handleClick = () => setNav(!nav);
  const { yacht_code, island } = useParams();
  const location = useLocation();
  const [scroll, setScroll] = useState(false);
  const detailsRef = useRef(null);  // <-- referencia al <details>

  const closeDetails = () => {
    if (detailsRef.current) {
      detailsRef.current.open = false;
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      setScroll(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);


  return (
    <>
      <div className={`hidden lg:flex transition-colors duration-300  z-20 fixed navbar ${scroll ? 'bg-[#000000bb]' : 'bg-[#00000055]'}`}>
        <div className="navbar-start">
          <Link to={'/'}>
            <img loading="lazy" className="w-[180px] h-[50px] 2xl:w-[180px] 2xl:h-[70px]  " src={logo} alt={logo} />
          </Link>
        </div>
        <div className="navbar-center uppercase">
          <ul className="menu menu-horizontal px-1 text-white text-[13px]">
            <li>
              <Link to={'/'} className={`h-full flex items-center hover:border-b-2 hover:border-b-orange-600 duration-100 ${location.pathname === '/' ? ' border-b-2 border-b-orange-600 ' : ''}`}>
                <h2>Home</h2>
              </Link>
            </li>
            <li>
              <Link to={'/our-history'} className={`h-full flex items-center hover:border-b-2 hover:border-b-orange-600 duration-100 ${location.pathname === '/our-history' ? ' border-b-2 border-b-orange-600 ' : ''}`}>
                <h2>About Us</h2>
              </Link>
            </li>
            <li>
              <details ref={detailsRef}>
                <summary className={`h-full flex items-center gap-2 duration-100 hover:border-b-2 hover:border-b-orange-600 ${location.pathname === '/galapagos-cruises' ? ' border-b-2 border-b-orange-600 ' :
                  location.pathname === `/galapagos-cruises/${yacht_code}` ? ' border-b-2 border-b-orange-600' : ''}`}>
                  Galapagos cruises
                </summary>
                <ul className="p-2 rounded-none bg-[#000000bb] w-full">
                  <li className='hover:text-orange-400'>
                    <Link to={`/galapagos-cruises`} onClick={closeDetails}>
                      <span>All</span>
                    </Link>
                  </li>
                  {
                    yachtState?.map(yacht => (
                      <li key={yacht.id} className='hover:text-orange-400'>
                        <Link to={`/galapagos-cruises/${yacht.code}`} onClick={closeDetails}>
                          <span>{yacht.name}</span>
                        </Link>
                      </li>
                    ))
                  }
                </ul>
              </details>
            </li>
            <li>
              <Link to={'/galapagos-islands'}
                className={`h-full flex items-center hover:border-b-2 hover:border-b-orange-600 duration-100 
                ${location.pathname === '/galapagos-islands' ? ' border-b-2 border-b-orange-600 ' :
                    location.pathname === `/galapagos-islands/${island}` ? ' border-b-2 border-b-orange-600 ' : ''}`}>
                <h2>ABOUT GALAPAGOS</h2>
              </Link>
            </li>
            <li>
              <Link to={'/last-minute-deals'}
                className={`h-full flex items-center hover:border-b-2 hover:border-b-orange-600 duration-100 
              ${location.pathname === '/last-minute-deals' ? ' border-b-2 border-b-orange-600 ' : ''}`}>
                <h2>Last minute deals</h2>
              </Link>
            </li>
            <li>
              <Link to={'/galapagos-blog'} className={`h-full flex items-center hover:border-b-2 hover:border-b-orange-600 duration-100 
              ${location.pathname === '/galapagos-blog' ? ' border-b-2 border-b-orange-600 ' : ''}`}>
                <h2>GALAPAGOS BLOG</h2>
              </Link>
            </li>
            <li>
              <Link to={'/social-responsability'} className={`h-full flex items-center hover:border-b-2 hover:border-b-orange-600 duration-100 
              ${location.pathname === '/social-responsability' ? ' border-b-2 border-b-orange-600 ' : ''}`}>
                <h2>SOCIAL RESPONSABILITY </h2>
              </Link>
            </li>
            <li>
              <Link to={'/contact-us'}
                className={`h-full flex items-center hover:border-b-2 hover:border-b-orange-600 duration-100 
              ${location.pathname === '/contact-us' ? ' border-b-2 border-b-orange-600 ' : ''}`}>
                <h2>Contact us</h2>
              </Link>
            </li>
          </ul>
        </div>
        <div className="navbar-end gap-3 justify-end items-center p-5 text-white">
          <a href='https://www.facebook.com/rolfwittmerfleet' aria-label="Visit our facebook" target="_blank" className='cursor-pointer transform transition-transform duration-300 hover:scale-125'>
            <FaFacebook size={23} />
          </a>
          <a href='https://www.instagram.com/rolfwittmer/?fbclid=IwAR3HYrhn4JlXxwOknep7bBgLS_8aMUeVV8agIgkwDAffFEa7wSzfwWkKXbE' aria-label="Visit our facebook" target="_blank" className='cursor-pointer transform transition-transform duration-300 hover:scale-125'>
            <FaInstagram size={23} />
          </a>
          <a href='https://www.linkedin.com/company/tip-top-travel-official/?viewAsMember=true' aria-label="Visit our facebook" target="_blank" className='cursor-pointer transform transition-transform duration-300 hover:scale-125'>
            <FaLinkedin size={23} />
          </a>
          <a href='https://www.youtube.com/@rolfwittmer9103/videos' aria-label="Visit our facebook" target="_blank" className='cursor-pointer transform transition-transform duration-300 hover:scale-125'>
            <FaYoutube size={23} />
          </a>
        </div>
      </div>
      {/* Hamburger */}
      <div onClick={handleClick} className='md:hidden z-20 fixed h-[90px] w-full text-white bg-black/70'>
        {!nav ?
          <div className='flex justify-between h-full items-center'>
            <Link to={'/'}>
              <img loading='lazy' className="w-[150px] h-[60px] " src={logo} alt={logo} />
            </Link>
            <div className='flex items-center gap-5 pr-8'>
              <FaBars size={23} />
            </div>
          </div>
          :
          < div className={!nav ? 'hidden' : 'fixed z-30  left-0 w-full h-screen  bg-[#d3d0ce] flex flex-col justify-center items-center text-gray-500'}>
            <div className='w-full flex justify-end pr-5'>
              <FaTimes size={23} />
            </div>
            <div className='flex justify-center items-center cursor-pointer mb-8 duration-75'>
              <Link to={'/'}>
                <img className="w-[200px] " src={logo} alt={logo} />
              </Link>
            </div>
            <div className='flex flex-col gap-10 uppercase items-center font-sans'>
              <Link to={'/our-history'} className='hover:text-orange-500 duration-75'>
                <h2>About Us</h2>
              </Link>
              <Link to={'/galapagos-cruises'} className='hover:text-orange-500 duration-75'>
                <h2>Galapagos cruises</h2>
              </Link>
              <Link to={'/galapagos-islands'} className='hover:text-orange-500 duration-75'>
                <h2>ABOUT GALAPAGOS</h2>
              </Link>
              <Link to={'/last-minute-deals'} className='hover:text-orange-500 duration-75'>
                <h2>Last minute deals</h2>
              </Link>
              <Link to={'/galapagos-blog'} className='hover:text-orange-500 duration-75'>
                <h2>GALAPAGOS BLOG</h2>
              </Link>
              <Link to={'/social-responsability'} className='hover:text-orange-500 duration-75'>
                <h2>SOCIAL RESPONSABILITY </h2>
              </Link>
              <Link to={'/contact-us'} className='hover:text-orange-500 duration-75'>
                <h2>Contact us</h2>
              </Link>
              <div className='flex gap-3 justify-center items-center p-5'>
                <a href='mailto:sales@tiptoptravel.ec' aria-label="seand mail" target='_blank' className='hover:text-orange-500 duration-75'>
                  <RiMailSendLine size={23} />
                </a>
                <a href='https://wa.link/u7kidg' aria-label="Contact us to whastapp" target='_blank' className='hover:text-orange-500 duration-75'>
                  <FaWhatsapp size={23} />
                </a>
                <a href='https://www.facebook.com/rolfwittmerfleet' aria-label="Visit our facebook" target='_blank' className='hover:text-orange-500 duration-75'>
                  <FaFacebook size={23} />
                </a>
                <a href='https://www.instagram.com/rolfwittmer/?fbclid=IwAR3HYrhn4JlXxwOknep7bBgLS_8aMUeVV8agIgkwDAffFEa7wSzfwWkKXbE' aria-label="Visit our instagram" target='_blank' className='hover:text-orange-500 duration-75'>
                  <FaInstagram size={23} />
                </a>
              </div>
            </div>
          </div>
        }
      </div >
    </>
  );
};

export default Navbar;
